import React, { createContext, useState } from 'react';

// Create a context object
export const GlobalContext = createContext();
export const GlobalProvider = ({ children }) => {
    const [gbStMachineUsers, setGbStMachineUsers] = useState(null);

    const setMachineUsers = (listMachineUsers) => {
        setGbStMachineUsers(listMachineUsers);
      }

      return (
        <GlobalContext.Provider value={{ gbStMachineUsers,setMachineUsers }}>
          {children}
        </GlobalContext.Provider>
      );


};